// extracted by mini-css-extract-plugin
export default {"errorModal":"styles_errorModal__4ihb-","content":"styles_content__YaWzh","button":"styles_button__NzmMM","title":"styles_title__hyyDu"};